import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-page-under-construction',
  standalone: true,
  imports: [RouterLink, TranslocoPipe],
  templateUrl: './page-under-construction.component.html',
  styleUrls: ['./page-under-construction.component.scss'],
})
export class PageUnderConstructionComponent {}
